module.exports = __webpack_public_path__ + "fonts/Gotham-Medium.bac38634.woff";